// extracted by mini-css-extract-plugin
export default {"wrapperTooltip":"Profile_wrapperTooltip__gwHSf","tooltip":"Profile_tooltip__TGLmY","mail":"Profile_mail__vPJL2","hr":"Profile_hr__hDkb6","item":"Profile_item__kAeCI"};